import { Component, OnInit, inject } from '@angular/core';
import { MatSlideToggleChange, MatSlideToggle } from '@angular/material/slide-toggle';
import { Router } from '@angular/router';
import { Guid } from 'guid-typescript';
import { NotificationModel } from 'src/app/models/notification.model';
import { NotificationService } from 'src/app/services/notification.service';
import { NotificationStatusEnum } from 'src/app/shared/enumerators/notification-status.enum';
import { UserService } from 'src/app/shared/services/user.service';
import { notificationImages } from 'src/assets/data/notification-images';
import { DatePipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PageHeaderComponent } from 'src/app/shared/ui/page-header/page-header.component';
import { EmptyStateComponent } from 'src/app/shared/ui/empty-state/empty-state.component';

@Component({
    selector: 'app-notifications-center',
    templateUrl: './notifications-center.component.html',
    styleUrls: ['./notifications-center.component.scss'],
    imports: [MatSlideToggle, MatButtonModule, MatIconModule, DatePipe, PageHeaderComponent, EmptyStateComponent]
})
export class NotificationsCenterComponent implements OnInit {
  private readonly notificationSrv = inject(NotificationService);
  private readonly router = inject(Router);
  usrSvc = inject(UserService);

  notificationsList: NotificationModel[] = [];
  notifications: NotificationModel[] = [];
  notificationImages = notificationImages;
  filterOnlyToRead = false;

  ngOnInit(): void {
    this.getNotifications();
  }

  getNotifications() {
    this.usrSvc.userDataChanged.subscribe((user) => {
      if (user) {
        this.notificationSrv
          .getAllNotificationsByUser(user.email!, 30, true, null)
          .subscribe((data) => {
            this.notificationsList = data;
            this.notifications = data;
          });
      }
    });
  }

  getNotificationIcon(type: any) {
    return this.notificationImages.find((x) => x.type == type)?.src;
  }

  markAllAsRead() {
    let list = this.notificationsList.filter(
      (x) => x.status != NotificationStatusEnum.Read
    );
    this.notificationSrv.markAllAsRead(list).subscribe((data: any) => {
      list.forEach((n) => {
        n.status = NotificationStatusEnum.Read;
      });
      this.notifications = this.notificationsList;
    });
  }

  showOnlyUnread(toggleChangeEvent: MatSlideToggleChange) {
    this.filterOnlyToRead = toggleChangeEvent.checked;
    if (toggleChangeEvent.checked) {
      this.notifications = this.notificationsList.filter(
        (x) => x.status == NotificationStatusEnum.Sent
      );
    } else {
      this.notifications = this.notificationsList;
    }
  }

  hasNotificationsToRead() {
    const toRead = this.notificationsList.filter(
      (x) => x.status == NotificationStatusEnum.Sent
    );
    return toRead.length > 0;
  }

  goSupplierDetail(id: string) {
    this.router.navigate(['/supplier'], { queryParams: { id } });
  }

  goToOADetails(assemblyOrderId: string) {
    this.router.navigate(['/ManufacturingOrder'], {
      queryParams: { assemblyOrderId },
    });
  }

  goToSapArticleDetails(manufacturingItemId: string) {
    this.router.navigate(['/SapArticles'], {
      queryParams: { manufacturingItemId },
    });
  }

  goToTaskDetails(taskId: string) {
    this.router.navigate(['/scheduleTasks'], { queryParams: { taskId } });
  }

  goToBudget(budgetId: string) {
    this.router.navigate(['/budget'], { queryParams: { id: budgetId } });
  }

  markNotification(id: Guid) {
    let notification = this.notificationsList.find((item) => item.id == id);

    if (notification?.status == NotificationStatusEnum.Sent) {
      this.notificationSrv.markAsRead(id).subscribe((data: any) => {
        if (notification) {
          notification.status = NotificationStatusEnum.Read;
        }
      });
    } else {
      this.notificationSrv.markAsUnread(id).subscribe((data: any) => {
        if (notification) {
          notification.status = NotificationStatusEnum.Sent;
        }
      });
    }
  }
}
